import { AnyAction } from 'redux';
import * as actionTypes from './loading.actions';
import { NetworkStatus } from './loading.actions';

type LoadingState = {
  overlay: { isVisible: boolean; message?: string };
  activity: { count: number };
  networkStatus: NetworkStatus;
};

const initialState: LoadingState = {
  overlay: { isVisible: false, message: undefined },
  activity: { count: 0 },
  networkStatus: 'fast',
};

const loadingReducer = (
  state: LoadingState = initialState,
  action: AnyAction
): LoadingState => {
  switch (action.type) {
    case actionTypes.LOADING_OVERLAY_SHOW:
      return {
        ...state,
        overlay: {
          isVisible: true,
          message: action.payload?.message,
        },
      };
    case actionTypes.LOADING_OVERLAY_HIDE:
      return {
        ...state,
        overlay: { isVisible: false, message: undefined },
      };
    case actionTypes.ACTIVITY_START:
      return {
        ...state,
        activity: { count: state.activity.count + 1 },
      };
    case actionTypes.ACTIVITY_END:
      return {
        ...state,
        activity: { count: Math.max(0, state.activity.count - 1) },
      };
    case actionTypes.NETWORK_STATUS_SET:
      return {
        ...state,
        networkStatus: action.payload,
      };
    default:
      return state;
  }
};

export default loadingReducer;
